import ToolAlignment from './ToolAlignment';
import { type Alignment } from '../../../types/aha-editor';

class ToolAlignJustify extends ToolAlignment {
  static toolName = 'Justify';
  static iconClass = 'fa-regular fa-align-justify';
  static alignment: Alignment = 'justify';
}

export default ToolAlignJustify;
